// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#planets-menu-content ul li {
  padding: 2px !important;
  overflow: hidden !important;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.disabled {
  opacity: 0.4 !important;
  opacity: var(--disabledOpacity, 0.4) !important;
  cursor: not-allowed !important;
  cursor: var(--disabledCursor) !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/planets-menu/planets-menu.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;AAC9B","sourcesContent":["#planets-menu-content ul li {\n  padding: 2px !important;\n  overflow: hidden !important;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.disabled {\n  opacity: 0.4 !important;\n  opacity: var(--disabledOpacity, 0.4) !important;\n  cursor: not-allowed !important;\n  cursor: var(--disabledCursor) !important;\n  -webkit-touch-callout: none !important;\n  -webkit-user-select: none !important;\n  -khtml-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
